import React from 'react'

function Footer() {
  return (
    <footer className='d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top'>
      <div className='col-md-4 d-flex align-items-center'>
        <a
          href='/'
          className='mb-3 me-2 mb-md-0 text-muted text-decoration-none'>
          <img src='favicon-32x32.png' alt='favicon' height={'24px'} />
        </a>
        <span className='text-muted'>Jeff Heller | 2023</span>
      </div>
      <ul className='nav col-md-4 justify-content-end list-unstyled d-flex'>
        <li className='ms-3 fs-5'>
          <a
            className='text-muted'
            href='https://github.com/Jheller11'
            target={'_blank'}
            rel='noreferrer'>
            <i className='fab fa-github-square'></i>
          </a>
        </li>
        <li className='ms-3 fs-5'>
          <a className='text-muted' href='mailto:heller.jeffrey@gmail.com'>
            <i className='fas fa-envelope'></i>
          </a>
        </li>
        <li className='ms-3 fs-5'>
          <a
            className='text-muted'
            href='https://www.linkedin.com/in/jeffreyaheller/'
            target={'_blank'}
            rel='noreferrer'>
            <i className='fab fa-linkedin'></i>
          </a>
        </li>
      </ul>
    </footer>
  )
}

export default Footer
